import { fromUnixTime } from 'date-fns';

import { STEP_TYPES } from './constants';

export function convertStepsToEditorFormat(visitStep, goalSteps) {
  const result = [];
  if (visitStep) {
    result.push({ type: STEP_TYPES.VISIT });
  }
  goalSteps.forEach((g) => result.push({ type: STEP_TYPES.GOAL, id: g.id }));

  return result;
}

export function convertGoalStepsToDBFormat(steps) {
  return steps.filter((s) => s.type === STEP_TYPES.GOAL).map((s) => s.id);
}

export function getFunnelStartedAt(steps, selectedSite) {
  const stepDates = steps
    .map((step) => {
      if (step.type === STEP_TYPES.VISIT) {
        return selectedSite?.webAnalyticsEnabledAt ? fromUnixTime(selectedSite.webAnalyticsEnabledAt) : null;
      }

      return step.createdAt ? fromUnixTime(step.createdAt) : null;
    })
    .filter(Boolean);

  if (!stepDates.length) return null;

  return stepDates.reduce((earliest, date) => (date < earliest ? date : earliest));
}
